import { render } from "./SettingsBrandPage.vue?vue&type=template&id=202bcf73&ts=true"
import script from "./SettingsBrandPage.vue?vue&type=script&lang=ts"
export * from "./SettingsBrandPage.vue?vue&type=script&lang=ts"

import "./SettingsBrandPage.vue?vue&type=style&index=0&id=202bcf73&lang=css"

import exportComponent from "/Users/paulbele/Code/repositories/maatoo-app-master/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__